var map = {
	"./3 squiggle.png": 5720,
	"./avo.png": 5750,
	"./axo.png": 2228,
	"./banana.png": 9615,
	"./bear.png": 9286,
	"./beety.png": 6647,
	"./berry.png": 3650,
	"./bunny.png": 3730,
	"./carrot.png": 6841,
	"./cherry.png": 3079,
	"./citrus.png": 4930,
	"./clock-small.svg": 6814,
	"./cloudy.png": 4384,
	"./cow.png": 7263,
	"./crabby.png": 7013,
	"./deer.png": 1872,
	"./doggy.png": 7188,
	"./duck.png": 919,
	"./dude.png": 288,
	"./dudehandup.png": 8488,
	"./elephant.png": 9779,
	"./flower.png": 7501,
	"./flowie.png": 4406,
	"./fox.png": 9394,
	"./frog.png": 3098,
	"./giraffe.png": 6834,
	"./goaty.png": 1824,
	"./hand.png": 207,
	"./handstandguy.png": 3390,
	"./heart.png": 150,
	"./hippo.png": 3346,
	"./icons/logo.svg": 6962,
	"./jaguar.png": 7722,
	"./jelly.png": 2142,
	"./kitty.png": 6095,
	"./koala.png": 2612,
	"./leafy.png": 2867,
	"./lion.png": 9090,
	"./liz.png": 1299,
	"./monkey.png": 3703,
	"./moon.png": 2783,
	"./mountain.png": 1097,
	"./mousey.png": 2442,
	"./mushroom.png": 90,
	"./mute.png": 419,
	"./olive.png": 2283,
	"./owlie.png": 6198,
	"./paper.png": 3172,
	"./piggy.png": 3894,
	"./plum.png": 9550,
	"./puppy.jpg": 484,
	"./puppy1.png": 6971,
	"./raccoon.png": 1281,
	"./remi.png": 3777,
	"./rooster.png": 7726,
	"./shelly.png": 39,
	"./slug.png": 645,
	"./snek.png": 2791,
	"./sounds/click.wav": 6007,
	"./sounds/tada.wav": 3797,
	"./squiggle.png": 7201,
	"./star.png": 9388,
	"./stones.png": 6446,
	"./tangerine.png": 5099,
	"./tomato.png": 3462,
	"./volume.png": 6818,
	"./w.png": 5597,
	"./watermelon.png": 2058,
	"./whale.png": 6253,
	"./wiggly.png": 9187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;